const routes = {
	branding: '/services/branding',
	developer: '/developer',
	partnership: '/partnership',
	aboutUs: '/about-us',
	services: '/services',
	caseStudies: '#case-studies',
	blog: '/blog',
	privacyPolicy: '/privacy-policy',
	brandquiz: '/brandquiz'
};

export default routes;
